import { useState } from 'react'
import SecureMarkdown from '@components/SecureMarkdown'
import { useUpdateBlockSubmission } from './hooks'
import BlockLayout from './BlockLayout'
import BlockActions from './BlockActions'

const TextBlock = ({
  content,
  moveToNextBlock,
  moveToPreviousBlock,
  isFirstBlock,
  isLastBlock,
  isSubmissionClosed,
  openSubmitModal,
  submissionStatus,
  submissionId,
  blockId
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { updateBlockSubmission } = useUpdateBlockSubmission({ educatorProjectSubmissionId: submissionId })

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submissionStatus === 'COMPLETED' || submissionStatus === 'RETURNED' || isSubmissionClosed) {
      if (isLastBlock) {
        openSubmitModal();
      } else {
        moveToNextBlock();
      }
      return;
    }

    setIsSubmitting(true);

    try {
      await updateBlockSubmission({ blockId, status: 'COMPLETED' });

      if (isLastBlock) {
        openSubmitModal();
      } else {
        moveToNextBlock();
      }
    } catch (error) {
      console.error('Error updating block submission:', error);
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleBack = () => {
    moveToPreviousBlock()
  }

  return (
    <form className="h-full" onSubmit={handleSubmit}>
      <BlockLayout>
        <BlockLayout.Actions>
          <BlockActions
            isFirstBlock={isFirstBlock}
            isLastBlock={isLastBlock}
            onBack={handleBack}
            isSubmissionClosed={isSubmissionClosed}
            submissionStatus={submissionStatus}
            isSubmitting={isSubmitting}
            tooltipText="Submissions are closed for this pathway"
          />
        </BlockLayout.Actions>
        <BlockLayout.Content>
          <SecureMarkdown content={content} />
        </BlockLayout.Content>
      </BlockLayout>
    </form>
  )
}

export default TextBlock
